import React, {useState} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import { orderBy } from '@progress/kendo-data-query';

import LoadingIndicator from '../../common/loadingIndicator';
import {channelCell, maskValueCell} from '../../common/sponsorships/list/sponsorshipListHelper';
import { changePublicationListPage, changePublicationListOrder } from '../publication.actions';
import { useAuth0, getSelectedTenantId } from '../../app/auth';
import * as selectors from '../publication.selectors';
import { metricName } from '../../common/constants';

function statusCell(props) {

    let linkComponent = null;
    if(props.dataItem.publicationUrl) {
        linkComponent = (<a href={props.dataItem.publicationUrl} target="blank">
                            <span className="k-icon k-i-hyperlink-open-sm"></span>
                        </a>);
    }

    return (
        <td>
            {props.dataItem[props.field]} 
            {linkComponent}
        </td>
    );
}

function priceCell(props) {
    return maskValueCell(props, 0);
}

function moneyMetricCell(props) {
    return maskValueCell(props);
}

function percentageMetricCell(props) {
    return maskValueCell(props, 2, 'percentage');
}

const PublicationListComponent = (props) => {

    const [sort, setSort] = useState([{ field: 'date', dir: 'desc'}]);
    const { getTokenSilently, user } = useAuth0();

    const onSortChange = async(event) => {
        setSort(event.sort);
        const token = await getTokenSilently();
        props.onSortChanged(event.sort[0], token, getSelectedTenantId(user, token));
    };

    const handlePageChanged = async(event) => {
        const token = await getTokenSilently();
        props.onPageChanged({
            take: event.page.take,
            skip: event.page.skip
        }, token, getSelectedTenantId(user, token));
    };

    const { publications, take, skip, total, isLoading } = props;

    if(isLoading) return <LoadingIndicator/>;

    const entityName = "performanceMetrics";
    const cpmColumnName = `${entityName}.${metricName.cpm}`;
    const cpcColumnName = `${entityName}.${metricName.cpc}`;
    const ctrColumnName = `${entityName}.${metricName.ctr}`;
    const clicksColumnName = `${entityName}.${metricName.clicks}`;
    const viewsColumnName = `${entityName}.${metricName.views}`;

    return (
        <Grid data={orderBy(publications, sort)} 
            sortable sort={sort}
            onSortChange={onSortChange}
            onPageChange={handlePageChanged}
            pageable={{ type: "input"}}
            take={take} skip={skip} total={total}
            className="grid-container">

            <GridColumn field="date" title="Date" format="{0:d-MMM-yy}" className="date-highlight" width="120" locked={true}/>
            <GridColumn field="channelName" title="Channel" cell={channelCell} sortable={false} width="230" locked={true}/>
            <GridColumn field="publicationStatusName" title="Status" cell={statusCell} width="140"/>
            <GridColumn field="price" title="Price" cell={priceCell}/> 
            <GridColumn field={viewsColumnName} title="Views" format="{0:n0}"/>
            <GridColumn field={cpmColumnName} title="CPM" cell={moneyMetricCell} sortable={false}/>
            <GridColumn field={clicksColumnName} title="Clicks" format="{0:n0}"/>
            <GridColumn field={cpcColumnName} title="CPC" cell={moneyMetricCell} sortable={false}/>
            <GridColumn field={ctrColumnName} title="CTR" cell={percentageMetricCell} sortable={false}/>
        </Grid>
    );
};

PublicationListComponent.propTypes = {
    publications: PropTypes.array.isRequired,
    skip: PropTypes.number.isRequired,
    take: PropTypes.number.isRequired,
    isLoading: PropTypes.bool.isRequired,
    total: PropTypes.number,
    onPageChanged: PropTypes.func,
    onSortChanged: PropTypes.func
};

function mapStateToProps(state) {
    const pagination = selectors.getPaginationInfo(state) || {};
    let skip = 0;
    let take = 0;
    if(pagination && Object.keys(pagination).length > 0) {
        skip = pagination.pageSize * (pagination.pageNumber - 1);
        take = pagination.pageSize;
    }
    return {
        publications: selectors.getPublications(state) || [],
        take,
        skip,
        total: pagination.recordTotal,
        isLoading: selectors.isPublicationDataLoading(state) || false

    };
}

function mapDispatchToProps(dispatch) {
    const props = {
      onPageChanged: (options, token, tenantId) => {
        dispatch(changePublicationListPage(options, token, tenantId));
      },
      onSortChanged: (options, token, tenantId) => {
          dispatch(changePublicationListOrder(options, token, tenantId));
      }
    };
    return props;
}
  
const PublicationList = connect(mapStateToProps, mapDispatchToProps)(PublicationListComponent);
export default PublicationList;